<ukata-conversation-view
  [conversation]="conversation"
  [showPlayerOnly]="showPlayerOnly"
></ukata-conversation-view>
